import { type Monitor, Signal } from "@suse-o11y/signal";
import last from "lodash/last";

export type MonitorStatusDrawerTabType = "supporting-metrics" | "related-issues";

export interface CheckStateChainElement {
	identifier: string;
	showImpactedComponent: Signal<boolean>;
	selectedTab: Signal<undefined | MonitorStatusDrawerTabType>;
}

export class CheckStateChain {
	public static init(initial: CheckStateChainElement) {
		return new CheckStateChain(initial, Signal([]));
	}

	private constructor(
		private readonly initial: CheckStateChainElement,
		private readonly chain: Signal<ReadonlyArray<CheckStateChainElement>>,
	) {}

	public peek(monitor: Monitor): CheckStateChainElement {
		return this.chain.read(monitor).at(-1) ?? this.initial;
	}

	public pop(): void {
		this.chain.write((chain) => chain.slice(0, -1));
	}

	public push(checkStateId: string): void {
		this.chain.write((chain) => {
			const latest = last(chain) ?? this.initial;

			return [
				...chain,

				// add next drawer state, should have the same initial state as the current one
				{
					identifier: checkStateId,
					showImpactedComponent: latest.showImpactedComponent.clone(),
					selectedTab: latest.selectedTab.clone(),
				},
			];
		});
	}

	public size(monitor: Monitor): number {
		return 1 + this.chain.read(monitor).length;
	}
}
